module.exports = __webpack_public_path__ + "img/stitch_along.aab83195.jpg";